import { type TFunction } from 'i18next';

import { type ClassRecording } from '../classroom/types';

export const getRecordingName = (t: TFunction, recording?: ClassRecording) => {
    if (!recording) {
        return '';
    }
    if (recording.name?.trim().length) {
        return recording.name.trim();
    }

    const recordingDate = new Date(recording.when);

    return t('lti:recordings.default-title', {
        interpolation: { escapeValue: false },
        date: `${recordingDate.toLocaleDateString()}, ${recordingDate.toLocaleTimeString()}`
    });
};
